import service from './service'
// 首页banner列表
export const getBannerList = (params: any) => service.get('/api/index/banner_list.json', params)
// 首页推荐商品推荐列表
export const getRecommend = (params: any) =>
  service.get('/api/index/recommend_list_pc.json', params)
// 首页推荐商品分页列表
export const getProList = () => service.get('/api/index/index_pro_type_list.json')
// 商品分页列表
export const getProductList = (params: object) =>
  service.get('/api/product/product_list_pc.json', params)
// 商品详情
export const getProductInfo = (params: object) =>
  service.get('/api/product/product_info.json', params)
// 搜索记录列表
export const getSearchList = (params: object) =>
  service.get('/api/product/search_list.json', params)
// 清空搜索记录
export const clearSearch = () => service.get('/api/product/clear_search_list.json')
// 加入购物车
export const addCart = (params: object) => service.get('/api/product/add_cart.json', params)
// 商品规格
export const productNature = (params: object) =>
  service.get('/api/product/product_nature.json', params)
// 商品价格
export const productPrice = (params: object) =>
  service.get('/api/product/product_price.json', params)
// 商品规格和价格
export const productNaturePrice = (params: object) =>
  service.get('/api/product/product_nature_price.json', params)
// 修改购物车
export const updateCard = (params: object) => service.get('/api/product/update_cart.json', params)
// 批量删除购物车
export const deleteCard = (params: object) => service.get('/api/product/delete_cart.json', params)
// 全选修改购物车
export const checkCart = (params: object) =>
  service.get('/api/product/batch_checked_cart.json', params)
// 购物车列表
export const cardList = (params: object) => service.get('/api/product/cart_list.json', params)
// 购物车数量
export const cardNum = (params: object) => service.get('/api/product/cart_num.json', params)
// 获取验证码
export const getCode = (params: object) => service.get('/api/login/get_code.json', params)
// 获取微信二维码（WEB）
export const getWxUrl = (params: object) => service.get('/api/login/get_wx_url.json', params)
// 微信回调（WEB）
export const wxCallback = (params: object) => service.get('/api/login/wx_callback.json', params)
// 注册登录
export const onRegister = (params: object) =>
  service.post('/api/login/register.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 登录
export const onLogin = (params: object) =>
  service.post('/api/login/login.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 密码登录
export const onPasswordLogin = (params: object) =>
  service.post('/api/login/pwd_login_pc.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 第三方登录绑定手机号
export const thirdRegister = (params: object) =>
  service.post('/api/login/third_register.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 忘记密码
export const updatePassword = (params: object) =>
  service.get('/api/user/update_password.json', params)
// 重置密码
export const updatePasswordNew = (params: object) =>
  service.get('/api/user/update_password_new.json', params)
// 解绑微信
export const untypingWechat = () => service.get('/api/user/untying_wechat.json')
// 根据父级查询商品分类列表(PC)
export const productTypeListPC = (params: object) =>
  service.get('/api/product_type/product_type_list_pc.json', params)
// 根据父级查询商品分类列表
export const productTypeList = (params: object) =>
  service.get('/api/product_type/product_type_list.json', params)
// 收货地址列表
export const addressList = (params: object) =>
  service.get('/api/address/receive_address_list.json', params)
// 保存收货地址
export const saveAddress = (params: object) =>
  service.get('/api/address/save_receive_address.json', params)
// 删除收货地址
export const deleteAdress = (params: object) =>
  service.get('/api/address/delete_receive_address.json', params)
// 默认收货地址
export const getDefaultAddress = () => service.get('/api/address/default_receive_address.json')
// 保存发票
export const saveInvoice = (params: object) => service.get('/api/invoice/save_invoice.json', params)
// 删除发票
export const deleteInvoice = (params: object) =>
  service.get('/api/invoice/delete_invoice.json', params)
// 发票列表
export const invoiceList = (params: object) => service.get('/api/invoice/invoice_list.json', params)
// 模糊搜索公司名称
export const searchInvoiceName = (params: object) =>
  service.get('/api/invoice/search_invoice_by_name.json', params)
// 查询税号
export const searchInvoiceNo = (params: object) =>
  service.get('/api/invoice/search_invoice_no.json', params)
// 创建订单
export const createOrder = (params: object) => service.get('/api/order/create_order.json', params)
// 再次下单
export const createOrderAgain = (params: object) =>
  service.get('/api/product/create_order_again.json', params)
// 创建单个订单
export const createOrderBuy = (params: object) =>
  service.get('/api/order/create_order_buy.json', params)
// 订单详情
export const orderDetail = (params: object) => service.get('/api/order/order_detail.json', params)
// 订单列表
export const orderList = (params: object) => service.get('/api/order/order_list_pc.json', params)
// 支付宝支付
export const aliPay = (params: object) => service.get('/api/order/alipay.json', params)
// 微信支付
export const wechatPay = (params: object) => service.get('/api/order/wechat_pay.json', params)
// 支付宝支付
export const aliPayPc = (params: object) => service.get('/api/order/alipay_pc.json', params)
// 微信支付
export const wechatPayPC = (params: object) =>
  service.get('/api/order/wechat_qrcode_pc2.json', params)
// 支付宝回调
export const alipayNotify = (params: object) => service.get('/api/order/alipay_notify.json', params)
// 订单取消支付
export const orderCancel = (params: object) => service.get('/api/order/order_cancel.json', params)
// 微信回调
export const weChatNotify = (params: object) => service.get('/api/order/wechat_notify.json', params)
// 获取当前系统时间
export const getSystemTime = () => service.get('/api/order/getSystemTime.json')
// 获取分类订单数量
export const orderNum = (params: object) => service.get('/api/order/order_num.json', params)
// 获取用户信息
export const getUserInfo = (params: object) => service.get('/api/user/user_info.json', params)
// 修改用户资料（性别，昵称，头像,QQ,openId）
export const updateUser = (params: object) => service.get('/api/user/update_user.json', params)
// 修改绑定手机号
export const updateMobileNo = (params: object) =>
  service.get('/api/user/update_mobileNo.json', params)
// 文件上传(支持多文件上传)
export const uploadFile = (params: object) =>
  service.post('/api/upload/upload_file.json', params, { fileType: '11' })
// 用户上传excel 文件
export const uploadExcelFile = (params: object) =>
  service.post('/api/upload/uploadExcelFile.json', params, { fileType: '21' })
// 订单计算运费
export const getFreight = (params: object) => service.get('/api/order/get_freight.json', params)
// 可以申请的售后类型
export const refundType = (params: object) => service.get('/api/refund/refundType.json', params)
// 申请售后
export const applyRefund = (params: object) => service.get('/api/refund/apply_refund.json', params)
// 售后申请详情
export const refundDetail = (params: object) =>
  service.get('/api/refund/refund_detail.json', params)
// 售后申请原因列表
export const reasonList = (params: object) =>
  service.get('/api/refund/after_sale_reason_list.json', params)
// 处理中列表
export const refundingList = (params: object) =>
  service.get('/api/refund/refunding_list_pc.json', params)
// 处理中列表
export const refundingPage = (params: object) =>
  service.get('/api/refund/refunding_page.json', params)
// 售后申请列表
export const refundList = (params: object) => service.get('/api/refund/refund_list_pc.json', params)
// 取消申请售后
export const cancelRefund = (params: object) =>
  service.get('/api/refund/cancel_refund.json', params)
// 售后退货物流填写
export const refundGoods = (params: object) =>
  service.get('/api/refund/refund_return_goods.json', params)
// 可以申请售后的子订单列表(分页)
export const getUnRefundList = (params: object) =>
  service.get('/api/order/get_unRefund_order_list.json', params)
// 分享朋友圈
export const SharePage = (params: object) =>
  service.get('/api/wechat/authentication/share_to_friend.json', params)
// 访问页面数据埋点
export const pageVisit = (params: object) => service.get('/api/index/page_visit.json', params)
// 微信授权(第一步)
export const wechatAuthorization = (params: object) =>
  service.post('/api/user/wechat_authorization.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 微信授权(第二步)
export const wechatAccessToken = (params: object) =>
  service.get('/api/user/wechat_access_token.json', params)
// 微信授权(第二步)
export const getUserInfor = () => service.get('/api/user/get_user_info.json')
// 获取商城分享配置
export const getShareConfig = (params: object) =>
  service.get('/api/index/get_index_share_config.json', params)
// 商城分享记录保存
export const saveShareRecord = (params: object) =>
  service.get('/api/index/save_share_record.json', params)
// 子订单售后申请列表
export const refundListDetail = (params: object) =>
  service.get('/api/refund/refund_list_by_detail_id.json', params)
// 获取等级列表
export const getLevel = (params: object) => service.get('/api/level/get_level_list.json', params)
// 获取积分明细列表
export const getIntegral = (params: object) =>
  service.get('/api/integral/get_integral_detail_list.json', params)
// 获取积分规则列表
export const getIntegralRule = (params: object) =>
  service.get('/api/integral/get_integral_rule_list.json', params)
// 订单积分抵扣和折扣情况
// 返回 data 含：discountAmount(等级权益), mallIntegralUseRule(积分规则),
//   mostPrice, integral, minInvoice, coupon/couponId(自动选券),
//   activityDiscountAmount(活动折扣，后端新增字段)
// confirmlist 行项赠品标识: isGift / giftFlag（值为 1 时视为赠品）
export const getIntegralDeduction = (params: object) =>
  service.get('/api/order/get_integral_deduction.json', params)
// 商品评价列表
export const getEvaluatelist = (params: object) =>
  service.get('/api/product/evaluate_list.json', params)
// 对评价点赞
export const followEvaluate = (params: object) =>
  service.get('/api/product/follow_evaluate.json', params)
// 确认收货
export const orderReceived = (params: object) =>
  service.get('/api/order/order_received.json', params)
// 发表评价
export const comment = (params: object) =>
  service.post('/api/product/add_evaluate.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 消息列表
export const messageList = (params: object) => service.get('/api/message/message_list.json', params)
// 消息缩略
export const messageSimple = (params: object) =>
  service.get('/api/message/message_simple.json', params)
// 添加/修改反馈
export const saveFeedBack = (params: object) =>
  service.get('/api/feedback/save_feedback.json', params)
// 消息设为已读
export const readMessage = (params: object) => service.get('/api/message/read_message.json', params)
// 批量删除消息
export const deleteMessage = (params: object) =>
  service.get('/api/message/delete_message.json', params)
// 售后页埋点
export const getDataRefund = (params: object) => service.get('/api/data/refund.json', params)
// 轮播图数据埋点
export const getDataBanner = (params: object) => service.get('/api/data/banner.json', params)
// 售后页搜索埋点
export const getRefundSearch = (params: object) =>
  service.get('/api/data/refund_search.json', params)
// 商品分类数据埋点
export const getDataProType = (params: object) => service.get('/api/data/pro_type.json', params)
// 热门商品数据埋点
export const getDataReCommend = (params: object) => service.get('/api/data/recommend.json', params)
// 移动端分享数据埋点
export const getDataShare = (params: object) => service.get('/api/data/share.json', params)
// 发票数据埋点
export const getDataInvoice = (params: object) => service.get('/api/data/invoice.json', params)
// 结算页数据埋点
export const getDataSettleMent = (params: object) =>
  service.get('/api/data/settlement.json', params)
// 交易管理-搜索数据埋点
export const getDataTradSearch = (params: object) =>
  service.get('/api/data/trade_search.json', params)
// 购物车数据埋点
export const getDataCard = (params: object) => service.get('/api/data/cart.json', params)
// 收货地址数据埋点
export const getDataAddress = (params: object) => service.get('/api/data/address.json', params)
// 订单数据埋点
export const getDataOrder = (params: object) => service.get('/api/data/order.json', params)
// 个人账户-等级埋点
export const getDataLevel = (params: object) => service.get('/api/data/level.json', params)
// 积分兑换列表
export const getIntegralExchange = (params: object) =>
  service.get('/api/integralExchange/getPage.json', params)
// 砍价列表
export const getBargain = (params: object) =>
  service.post('/api/bargain/getPage.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 积分兑换记录
export const getForRecord = (params: object) =>
  service.get('/api/order/integral_exchange_order_page.json', params)
// 积分兑换商品详情
export const getIntegralExchangeDetail = (params: object) =>
  service.get('/api/integralExchange/detail.json', params)
// 创建订单（积分兑换）
export const integralExchangeOrder = (params: object) =>
  service.post('/api/order/integral_exchange_order.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 砍价发起情况列表
export const getBargainUser = (params: object) =>
  service.post('/api/bargain/getShowList.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 砍价商品详情
export const getBargainGoodsDetails = (params: object) =>
  service.get('/api/bargain/product_detail.json', params)
// 发起砍价
export const startBargain = (params: object) =>
  service.post('/api/bargain/start_bargain.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 砍价中
export const bargaining = (params: object) =>
  service.post('/api/bargain/bargaining.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 创建订单(砍价)
export const createBargainOrder = (params: object) =>
  service.post('/api/order/create_bargain_order.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 导入帐号接口
export const importAccount = (params: object) =>
  service.post('/api/account/importAccount.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 客户端聊天页加载，返回客服id
export const indexLoad = (params: object) =>
  service.post('/api/account/indexLoad.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 客户端发送消息状态
export const validateStatus = (params: object) =>
  service.post('/api/account/validateStatus.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 客服信息;
export const custerInfo = (params: object) =>
  service.post('/api/account/custerInfo.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 查询聊天记录详情;
export const queryMessageRecordDetail = (params: object) =>
  service.post('/api/account/queryMessageRecordDetail.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 用户端输入框验证状态 true:可发送，false:置灰;
export const validateInputStatus = (params: object) =>
  service.post('/api/account/validateInputStatus.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 获取商品详情
export const productInfo = (params: object) => service.get('/api/account/productInfo.json', params)
// 获取首页导航列表
export const getIndexNav = (params: object) => service.get('/api/indexNav/list.json', params)
// 获取首页导航详情
export const getIndexNavDetails = (params: object) => service.get('/api/indexNav/get.json', params)
// 获取商品详情优惠券列表
export const getPreferenCoupon = (params: object) =>
  service.get('/api/preferenCoupon/list.json', params)
// 领取优惠券
export const receiveCoupon = (params: object) =>
  service.get('/api/receiveCoupon/receiveCoupon.json', params)
// 获取未使用优惠券数量
export const getUnableNum = (params: object) =>
  service.get('/api/receiveCoupon/getUnableNum.json', params)
// 获取优惠券使用说明
export const getInstruction = () => service.get('/api/preferenCoupon/getInstruction.json')
// 根据状态获取优惠券列表
export const getStatusCouponList = (params: object) =>
  service.get('/api/receiveCoupon/list.json', params)
// 获取商品优惠券列表
export const getCouponList = (params: object) =>
  service.get('/api/receiveCoupon/useCoupon.json', params)
// 获取商品优惠券分类列表
export const getClassifyProductType = (params: object) =>
  service.get('/api/receiveCoupon/classifyProductType.json', params)
// 获取优惠券使用说明
export const getUseCoupon = (params: object) =>
  service.post('/api/receiveCoupon/queryUseCoupon.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 首页轮播图
export const getcustomizedBannerList = (params: object) =>
  service.get('/api/customized/getBananList.json', params)
// 首页轮播图详情
export const bananDetail = (params: object) =>
  service.get('/api/customized/bananDetail.json', params)
// 代打印材质列表
export const getInsteadList = (params: object) =>
  service.get('/api/insteadPrint/getInsteadList.json', params)
// 查询商品规格尺寸
export const getRfidInfo = (params: object) =>
  service.get('/api/insteadPrint/getRfidInfo.json', params)
// 新增代打印工单
export const createPrintShow = (params: object) =>
  service.post('/api/insteadPrint/createPrintShow.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 新增耗材定制工单
export const createCustomizedShow = (params: object) =>
  service.post('/api/customized/createCustomizedShow.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 提交记录
export const getOrderRecord = (params: object) =>
  service.get('/api/insteadPrint/getShowOrderRecord.json', params)
// 提交记录详情
export const orderRecordDetail = (params: object) =>
  service.get('/api/insteadPrint/orderRecordDetail.json', params)
// 定制耗材列表
export const getMaterialList = (params: object) =>
  service.get('/api/customized/getMaterialList.json', params)
// 定制耗材 成品设置类型列表
export const endProductList = (params: object) =>
  service.get('/api/customized/endProductList.json', params)
// 定制耗材 成品设置类型详情
export const endProductDetail = (params: object) =>
  service.get('/api/customized/endProductDetail.json', params)
// 定制耗材 成品设置颜色列表
export const endProductColorList = (params: object) =>
  service.get('/api/customized/endProductColorList.json', params)
// 定制耗材 成品设置颜色详情
export const endProductColorDetail = (params: object) =>
  service.get('/api/customized/endProductColorDetail.json', params)
// 代打印材质说明
export const insteadTroduce = (params: object) =>
  service.get('/api/insteadPrint/insteadTroduce.json', params)
// 定制耗材 材质说明
export const insteadTroduceCustomized = (params: object) =>
  service.get('/api/customized/insteadTroduce.json', params)
// 查询首购特惠gif
export const queryFirstBuy = (params: object) =>
  service.get('/api/index/queryFirstBuy.json', params)
// 首页特惠优惠券
export const preferenCoupon = (params: object) =>
  service.get('/api/preferenCoupon/hideCoupon.json', params)
// 定制耗材 材质说明
export const insteadPrintProductList = (params: object) =>
  service.get('/api/insteadPrint/product_list_pc.json', params)
// 查询热搜词列表信息
export const hotWordsList = (params: object) => service.get('/api/hotWords/list.json', params)
// 热词埋点
export const hotWordsSearchJson = (params: object) =>
  service.post('/api/hotWords/search.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 查询热搜词
export const hotWordsSelect = (params: object) => service.get('/api/hotWords/select.json', params)
// 弹窗图片
export const popularizeList = (params: object) => service.get('/api/popularize/list.json', params)
// 领取弹窗图片
export const popularizeReceive = (params: object) =>
  service.post('/api/popularize/receive.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 关闭弹窗
export const popularizeClose = (params: object) => service.get('/api/popularize/close.json', params)
// 获取活动列表
export const flashSaleList = (params: object) => service.get('/api/flashSale/list_pc.json', params)
// 修改确认订单商品数量
export const updateBuyNum = (params: object) =>
  service.post('/api/order/updateBuyNum.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })
// 查询参与情况
export const getInvolvement = () => service.get('/api/flashSale/getInvolvement.json')
// 领取广告图优惠卷
export const receiveFirstBuyCoupon = (params: object) =>
  service.get('/api/receiveCoupon/receiveFirstBuyCoupon.json', params)
// 打印尺寸
export const queryPrintSize = (params: object) =>
  service.get('/api/index/queryPrintSize.json', params)
// 常用推荐
export const normalRecommend = (params: object) =>
  service.get('/api/index/normalRecommend.json', params)
// 清空单个搜索记录
export const clearSingleSearchList = (params: object) =>
  service.get('/api/product/clear_single_search_list.json', params)
// 首页广告图单击埋点
export const indexPostion = (params: object) => service.get('/api/index/indexPostion.json', params)
// 单击常用推荐商品埋点
export const dataNormalRecommend = (params: object) =>
  service.get('/api/data/normalRecommend.json', params)
// 单击快速查找标签纸埋点
export const printLabelSize = (params: object) =>
  service.get('/api/data/printLabelSize.json', params)
// 限时抢购埋点
export const flashSalePageVisit = (params: object) =>
  service.get('/api/flashSale/pageVisit.json', params)
// 获取推荐耗材商品
export const recommendProductInfo = (params: object) =>
  service.get('/api/product/recommend/product_info.json', params)
// 获取推荐耗材商品
export const exchangeProductInfo = (params: object) =>
  service.get('/api/product/recommend/exchange/product_info.json', params)
// 白拿推荐提示
export const exchangeRecord = (params: object) =>
  service.get('/api/product/recommend/exchange/record.json', params)

// 商品类型-全部机型-请选择机型列表
export const deviceList = (params: object) =>
  service.get('/api/applet/service/v2/device/list.json', params)

// 商品类型-全部尺寸-请选择标签尺寸
export const sizeList = (params: object) =>
  service.get('/api/applet/service/product_type/size/list.json', params)

//购物车价格明细
export const price_detail = (params: object) =>
  service.get('/api/product/price_detail.json', params)
// 自动领取优惠卷
export const auto_receive_coupon = (params: object) => service.get('/api/receiveCoupon/auto_receive_coupon.json', params);

// 商品价格计算
export const calc_price = (params: object) => service.get('/api/product/product_info/calc_price.json', params);


// 浏览商品记录
export const browser_history = (params: object) =>
  service.post('/api/applet/product/browser/history.json', params, {
    ContentType: 'application/x-www-form-urlencoded',
  })

  //支付成功是否白拿状态
export const exist_pay = (params: object) => service.get('/api/order/exchange/exist_pay.json', params);

//售后是否白拿状态
export const exist_record = (params: object) => service.get('/api/refund/exchange/exist_record.json', params);

// 活动页渲染数据
export const customActivityRender = (params: object) =>
    service.get('/api/customActivity/render.json', params)


// 商品活动详情
export const marketingActivityDetails = (params: object) =>
    service.get('/api/mall_marketing_activity/detail.json', params)


// 售后单检查
export const refundRecord = (params: object) =>
    service.get('/api/refund/activity/privileges/record.json', params)
  